import { lazy, Suspense } from "react";

import { Route, Routes } from "react-router-dom";

import Hourglass from "../components/common/Hourglass";

// Eagerly loaded public/lightweight pages
import AboutPage from "../pages/AboutPage";
import CopyrightPage from "../pages/CopyrightPage";

// Lazy-loaded pages
const HomePage = lazy(() => import("../pages/HomePage"));
const PrivacyPage = lazy(() => import("../pages/PrivacyPage"));
const TermsPage = lazy(() => import("../pages/TermsPage"));

export default function RouteTable() {
  return (
    <Suspense fallback={<Hourglass />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about/*" element={<AboutPage />} />
        <Route path="/copyright" element={<CopyrightPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* God only routes */}
      </Routes>
    </Suspense>
  )
}